module.exports = __webpack_public_path__ + "img/ratings-star.92ee83f6.svg";